module.exports = __webpack_public_path__ + "img/2.8a7d0f17.jpg";